var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"city"},[_c('p',{staticClass:"clearfix btn"},[_c('span',{staticClass:"fl",on:{"click":_vm.isNo}},[_vm._v("取消")]),_vm._v(" "),_c('span',{staticClass:"fr",on:{"click":_vm.isOk}},[_vm._v("确定")])]),_vm._v(" "),_c('mt-picker',{attrs:{"slots":_vm.slots,"valueKey":"region_name"},on:{"change":_vm.onValuesChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b3f108","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/city.vue
// module id = null
// module chunks = 